export function sortFeatureGates(input: { [key: string]: any }) {
    if (!input) {
        return input;
    }

    return Object.keys(input)
        .sort((a, b) => {
            const aHasGroup = a.indexOf(':') > 0;
            const bHasGroup = b.indexOf(':') > 0;

            if (aHasGroup && !bHasGroup) {
                return 1; // put b before a
            } else if (!aHasGroup && bHasGroup) {
                return -1; // keep order
            }

            return a.localeCompare(b, undefined, { sensitivity: 'base' });
        })
        .map(x => [x, input[x]]);
}
